export default {
  $projectBody: $('.post-body'),
  $homeServices: $('.home-services'),
  $window: $(window),
  $homeIntro: $('.home-intro'),
  // $isMobile: false,

  init() {
    // this.measureWindowWidth();
    // this.$window.on('resize', () => this.measureWindowWidth());

    // if (!this.$isMobile) {
    //   this.$window.on('scroll', () => this.onScroll());
    //   setTimeout(() => {
    //     this.onScroll();
    //   }, 300);
    // }

    this.setupTestimonials();
  },
  // measureWindowWidth() {
  //   if (window.innerWidth < 992) {
  //     this.$isMobile = true;
  //   } else {
  //     this.$isMobile = false;
  //   }
  // },
  // onScroll() {
  //   const scrollTop = this.$window.scrollTop();
  //   const servicesHeight = this.$homeServices.height();

  //   if (servicesHeight - this.$window.height() + this.$homeServices.offset().top < scrollTop) {
  //     this.$homeIntro.removeClass('is-sticky');
  //   } else {
  //     this.$homeIntro.addClass('is-sticky');
  //   }
  // },
  setupTestimonials() {
    $('.testimonials-slider').slick({
      centerPadding: '0',
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      gap: 20,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          },
        },
      ],
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
